import React from 'react';
import { XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Tag } from '../../services/tagService';

interface DeleteTagModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tag: Tag | null;
  isLoading: boolean;
}

export const DeleteTagModal: React.FC<DeleteTagModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  tag,
  isLoading
}) => {
  if (!isOpen || !tag) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
          </div>
          <div className="ml-3 w-0 flex-1">
            <h3 className="text-lg font-medium text-gray-900">
              Excluir Tag
            </h3>
            <div className="mt-2 text-sm text-gray-500">
              <p>
                Tem certeza que deseja excluir a tag <strong>"{tag.name}"</strong>?
              </p>
              <p className="mt-2">
                Esta ação não pode ser desfeita e todos os documentos associados a esta tag serão afetados.
              </p>
            </div>
          </div>
          <div className="ml-auto pl-3">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50"
            disabled={isLoading}
          >
            {isLoading ? 'Excluindo...' : 'Excluir Tag'}
          </button>
        </div>
      </div>
    </div>
  );
}; 